import Vue from 'vue';
import moment from 'moment';

Vue.filter('todate', function(value: string) {
    if(!value) return;
    return moment(value).format("YYYY-MM-DD")
})